import React, { Dispatch, useState, useEffect } from 'react'
import { Row, Col, Button, Spin, message } from "antd"
import { EditOutlined } from "@ant-design/icons";
import { saveExtractedData, updateTray } from '../../api/trayTable/TrayTableMethods';
import { useParams } from 'react-router-dom';
import { STATUS, IBracelet } from "../interface/interface"
import { LoadingOutlined } from "@ant-design/icons"
import { getBpProgression } from '../../api/BPTable/BPTableMethods';
import { useNavigate } from 'react-router-dom';
import './extractedData.css'
import ModalError from './ModalError';
import TrayIdModal from './TrayIdModal';
import { percentageToPos } from '../Utils/percentageToPos';
import ModalForceValidate from './ModalForceValidate';
import { getOlpnCount } from '../../api/OLPN/olpn';
import { dkError } from '../../api/errors/errors';
import * as $ from 'jquery';
import TrayError, { ErrorActions } from './TrayError';
import { TrayMain } from './TrayMain';

const NOK: string = "#F45B69"
const OK: string = "#11d42b"
const WATCH: string = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAABG0lEQVRIie2XwWrCQBCGvwpNb4J9q+Zi9S59AxV6aF+kPpFCb/XiQfsGelCvBrWHzFIRVmd2N6DiD8NCMv98ZJPszsKVKAe+gQVQSMzlWl4VtAGsgb0n1pKjUs0AfgPqJ+7XgY6hnkqPwC/+p3Uxk9xk6iugLnqpoC1gaQAvxROlNrAzQF3sYuFjKfQBZIr8DPgUz08MeCNFNNBD+F68wXJTF+ob+hIeFAU0eT6f12tZQJKqavAo1Bj7jr262am+gy8fXMhoWTKfjrxB4ImM70p4JrmH3iC1CNsWt8BrDBgpYG0EmrFQp54B3E0FhbKBmymgU5TNnvZ3KoCBIu+LM19ziJ453dCvMDT0VrkjzJyytdnwf4R5qQqaVH/xCZe9Dt3NEwAAAABJRU5ErkJggg=="


const ExtractedData = (props: {
  data: any, setData: Dispatch<any>, setValidated: Dispatch<boolean>, validated: boolean, setShowImage: Dispatch<string | undefined>,
  setStatus: Dispatch<string>, setProgression: any, progress: any, OLPN: any, canvasRef: any, isRefresh: boolean, qrData: string | undefined,
  setCountOLPN: Dispatch<number>, setPendingTray: Dispatch<number>, tray: boolean, setTray: Dispatch<boolean>, trayID: string, setTrayID: Dispatch<string>
}) => {
  const { data, setData, setValidated, validated, setShowImage, setStatus, OLPN, progress, canvasRef, isRefresh, setTray } = props
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<boolean>(false)
  const [bList, setBList] = useState<IBracelet[]>([])
  const [modal, setModal] = useState<boolean>(false)
  const [title, setTitle] = useState<string>("")
  const [trayId, setTrayId] = useState<string | undefined>("")
  const [trayModal, setTrayModal] = useState<boolean>(false)
  const [wrongCount, setWrongCount] = useState<string | undefined>(undefined)
  const [exceedCount, setExceedCount] = useState<string | undefined>(undefined)
  const [isForced, setForced] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>("")
  const { bpId, sku, trayNumber } = useParams()

  const navigate = useNavigate()

  useEffect(() => {
    getProgression()
  }, [])

  useEffect(() => {
    $(document).on('keypress', function (e) {
      if (e.key === "Enter" && !error) {
        handleValidate()
      } else if (e.key === "Enter" && error) {
        setForced(true)
      }
    });
    return () => {
      $(document).off()
    }
  }, [data, OLPN, trayId, error])

  useEffect(() => {
    if (!data || (data && data.data.length === 0)) return
    else {
      setWrongCount(undefined)
      setExceedCount(undefined)
      countBracelets(data.data?.predictions[0]?.Bracelets)
      setTrayId(sessionStorage.getItem("decodedText") ?? data.data?.predictions[0]?.trayId)
    }
  }, [data])

  useEffect(() => {
    if (props.trayID) {
      setTrayModal(true)
      setTrayId(props.trayID)
    }
  }, [props.trayID])

  const drawBox = async (data) => {
    const image = document.getElementById("image_screenshot") as HTMLImageElement | undefined
    const canvas: any = canvasRef.current
    if (canvas && image) {
      const ctx = canvas.getContext('2d')
      ctx.canvas.width = image.width;
      ctx.canvas.height = image.height
      ctx.lineWidth = 3;
      for (var elem of data) {
        if (image?.clientWidth && image?.clientHeight) {
          ctx.beginPath()
          const x = percentageToPos(image?.clientWidth, elem.bbox.topleft[0])
          const y = percentageToPos(image?.clientHeight, elem.bbox.topleft[1])
          const width = percentageToPos(image?.clientWidth, elem.bbox.width)
          const height = percentageToPos(image?.clientHeight, elem.bbox.height)
          var color: string = ""
          if (elem.sku !== sku) {
            color = NOK
            ctx.font = "30px Arial";
            ctx.fillStyle = NOK;
          } else
            color = OK
          ctx.strokeStyle = color;
          ctx.rect(x, y, width, height)
          ctx.stroke()
        }
      }
    }
  }

  const handleValidate = async (count: any[] | undefined = undefined, forced: boolean = false) => {
    if (trayId?.length === 0) return message.error("L'identifiant de plateau ne peut pas etre vide")
    if (!navigator.onLine)
      return message.error("Aucune connexion. impossible de valider le plateau")
    const path = sessionStorage.getItem("s3Path")
    setLoading(true)
    const skuList = data.data?.predictions[0]?.Bracelets
    const bpNumber: number = bpId ? bpId as unknown as number : 0
    if (!OLPN) return message.error("Aucun oLPN n'est ouvert. Veuillez en crée un afin de valider le plateau.")
    var res: any = undefined
    if (count)
      res = await saveExtractedData(bpNumber, trayId, path, STATUS.SUCCESS, count, count.length, OLPN, forced)
    else
      res = await saveExtractedData(bpNumber, trayId, path, STATUS.SUCCESS, skuList, data.data?.predictions[0]?.Bracelets.length, OLPN, forced)
    sessionStorage.removeItem('error');
    sessionStorage.setItem("complete", new Date().toISOString())
    sessionStorage.removeItem("decodedText")
    sessionStorage.removeItem("image")
    renderMessage("Plateau validé", "success")
    props.setTrayID("")
    setTrayId("")
    setStatus("")
    setData(undefined)
    setValidated(true)
    setShowImage(undefined)
    setLoading(false)
    getProgression()
    return res
  }

  const getProgression = async () => {
    if (bpId) {
      const res = await getBpProgression(bpId)
      props.setProgression(res)
      const count = await getOlpnCount(OLPN)
      props.setCountOLPN(count.total)
    }
  }

  const getSum = (braceletList) => {
    let sum = 0
    braceletList.forEach((a) => sum += a.count)
    return sum
  }

  const countBracelets = (bracelets: any[]) => {
    var braceletList: IBracelet[] = []
    let total = progress.progression[0] + bracelets.length
    drawBox(bracelets)
    if (total > progress.progression[1]) {
      sessionStorage.setItem("error", JSON.stringify({ type: "count", text: `${bracelets.length} bracelets ont été comptés. Confirmez vous que les bracelets sont en réalité au bon nombre ?` }))
      setStatus("error")
      setError(true)
      setExceedCount((total) + " bracelets totaux au lieu des " + progress.progression[1] + " bracelets attendus")
      setErrorMessage((total) + " bracelets totaux au lieu des " + progress.progression[1] + " bracelets attendus")
    }
    if (total !== progress.progression[1]) {
      if (bracelets.length !== 10 && bracelets.length !== 15 && bracelets.length !== 5) {
        setStatus("error")
        setError(true)
        setWrongCount("Le nombre de bracelets est incorrecte: " + bracelets.length + " bracelets détéctés")
        setErrorMessage("Le nombre de bracelets est incorrecte: " + bracelets.length + " bracelets détéctés")
        sessionStorage.setItem("error", JSON.stringify({ type: "count", text: `${bracelets.length} bracelets ont été comptés. Confirmez vous que les bracelets sont en réalité au bon nombre ?` }))
        return
      }
    }
    let barcode = 0
    bracelets.forEach((elem, index) => {
      if (elem?.sku !== sku) {
        let tmp = braceletList.findIndex((i) => i.sku === elem.sku)
        if (tmp >= 0)
          braceletList[tmp].count += 1
        else
          braceletList.push({ ...elem, count: 1 })
      }
      if (!elem.barcode2 || elem?.barcode2?.length === 0)
        barcode += 1
    })
    if (barcode > 0)
      sessionStorage.setItem("error", JSON.stringify({ type: "barcode", text: `Le code barre “Chine” n’a pas été détecté sur ${barcode} bracelets. Confirmez vous qu’ils sont en réalité présents ?` }))
    if (braceletList.length > 0) {
      setStatus("error")
      setError(true)
      setBList(braceletList)
      let count = getSum(braceletList)
      setErrorMessage(`${count} bracelets ont un SKU détécté comme étant différent du BP: ${bpId}. Souhaitez vous les comptabilier ?`)
      sessionStorage.setItem("error", JSON.stringify({ type: "sku", text: `${count} bracelets ont un SKU détécté comme étant différent du BP: ${bpId}. Souhaitez vous les comptabilier ?` }))
    } else {
      setStatus("complete")
      setError(false)
      setBList(bracelets)
    }
  }

  const renderMessage = (text: string, type: string) => {
    message[type](text)
  }

  const handleRestart = async () => {
    if (sessionStorage.getItem("s3Path") && sessionStorage.getItem("result") && bpId) {
      let err: any = sessionStorage.getItem("error")
      if (err) {
        err = await JSON.parse(err)
        await dkError(sessionStorage.getItem("s3Path"), bpId, err.type, sessionStorage.getItem("result"))
      }
    }
    sessionStorage.removeItem("image")
    sessionStorage.removeItem("result")
    sessionStorage.removeItem("decodedText")
    props.setTrayID("")
    setStatus("")
    setShowImage(undefined)
    setData(undefined)
    setTrayId("")
    setValidated(true)
    setLoading(false)
    getProgression()
  }

  const handleUpdate = async () => {
    setLoading(true)
    const path = sessionStorage.getItem("s3Path")
    const tray = trayId
    if (trayId?.length === 0) return message.error("L'identifiant de plateau ne peut pas etre vide")
    const skuList = data.data?.predictions[0]?.Bracelets
    if (bpId) {
      await updateTray(STATUS.SUCCESS, skuList, data.data?.predictions[0]?.Bracelets.length, path, tray, bpId)
      if (trayNumber)
        navigate(-1)
      else {
        renderMessage("Plateau validé", "success")
        sessionStorage.removeItem("image")
        sessionStorage.removeItem("result")
        sessionStorage.removeItem("decodedText")
        props.setTrayID("")
        setStatus("")
        setShowImage(undefined)
        setData(undefined)
        setTrayId("")
        setValidated(true)
        setLoading(false)
        getProgression()
      }
    }
  }

  console.log(trayId)

  const handlePause = async () => {
    setModal(true)
  }

  const TrayInfo = (props: { bracelets: IBracelet[] }) => (
    <>
      {exceedCount &&
        <span className='tray-error'>{exceedCount}</span>
      }
      {error ? <TrayError bracelets={props.bracelets} wrongCount={wrongCount} handleRestart={handleRestart} handlePause={handlePause} loading={loading} setForced={setForced} />
        :
        <>
          <Row >
            <Col md={24} xs={24} className='tray-number'>
              <div className='tray-count'>
                x{data.data && data.data.predictions && data.data?.predictions[0]?.Bracelets.length}
                <img className='watch-icon' src={WATCH} alt="extracted" />
              </div>
            </Col>
            <br />
            <Col md={24} xs={24}>
              <div className='tray-info'>{data.data && data.data.predictions && data.data?.predictions[0]?.Bracelets.length && data.data?.predictions[0]?.Bracelets[0].barcode3}</div>
              <div className='tray-sku'>SKU {data.data && data.data.predictions && data.data?.predictions[0]?.Bracelets.length && data.data?.predictions[0]?.Bracelets[0].sku}</div>
            </Col>
          </Row>
          {exceedCount && <ErrorActions handleRestart={handleRestart} handlePause={handlePause} loading={loading} setForced={setForced} />}
        </>
      }
    </>
  )

  return (
    <Row style={{ width: '100%' }} >
      <ModalForceValidate setModal={setForced} modal={isForced} setLoading={setLoading} setData={setData} setShowImage={setShowImage} trayId={trayId} handleValidate={handleValidate} error={errorMessage} data={data?.data?.predictions} />
      <ModalError modal={modal} setModal={setModal} title={title} setTitle={setTitle}
        setLoading={setLoading} data={data} setData={setData} setShowImage={setShowImage} trayId={trayId}
        forced={isForced} handleValidate={handleValidate} isRefresh={isRefresh} setPendingTray={props.setPendingTray}
      />
      <TrayIdModal setTrayModal={setTrayModal} trayModal={trayModal} setTrayId={setTrayId} trayId={trayId} />
      <Col xs={24} style={{ textAlign: 'center', paddingBottom: '0.5rem' }}>
        {trayId?.length === 0 || !trayId ? <span>Aucun ID détécté</span> : <span>ID plateau: {trayId}</span>}
        <Button style={{ marginLeft: '0.5rem' }} onClick={() => {
          setTray(true)
        }}><EditOutlined /></Button>
      </Col>
      <Col xs={24} >
        {
          data && data.data && data.data.length > 0 &&
          <TrayMain countBC={data.data?.predictions[0]?.NumberBC} countBL={data.data?.predictions[0]?.NumberBL} trayId={trayId} />
        }
      </Col>
      <Col xs={24} >
        <TrayInfo bracelets={bList} />
      </Col>
      <Col xs={24}>
        {!validated && !error && !exceedCount &&
          <>
            <div className='button-validate-div'>
              <Spin indicator={<LoadingOutlined className='loading-icon' />} spinning={loading}>
                <Button id="validate-tray" disabled={loading} className='validate-control' onClick={() => trayNumber ? handleUpdate() : handleValidate()}>Valider contrôle</Button>
              </Spin>
            </div>
          </>
        }
      </Col>
    </Row>
  )
}

export default ExtractedData